







































import {Component, Mixins} from "vue-property-decorator";
import NumberGenerator from "@/common/mixins/numberGenerator";
import QDetailModal from "@/components/qDetailModal.vue";
import Menu from "@/model/menu";
import OrderComponent from "@/components/order/orderComponent.vue";
import itemApi from "@/api/itemApi";
import {namespace} from "vuex-class";
import store from "@/store";

const menuStore = namespace("MenuStore")

@Component({
  name: "RecommendationList",
  components: {OrderComponent, QDetailModal},
})
export default class RecommendationList extends Mixins(NumberGenerator) {
  @menuStore.Getter
  getMenuList!: Menu[];

  public menuRecommendedList: Menu[] = null;

  async mounted() {
    this.menuRecommendedList = await this.initRecommendationList()
  }

  async initRecommendationList() {
    const menuRecommended = []
    console.log(this.getMenuList)
    if ( this.getMenuList.length === 0) {
      const items = await itemApi.index()
      items.map(value => {
        store.dispatch('MenuStore/addMenuToList', value);
      })
      const menuList = await store.dispatch('MenuStore/getAllMenu')
      menuList.map(value => {
        if (value.ranking !== "" && Number.parseInt(value.ranking) > 0) {
          menuRecommended.push(value)
        }
      })
    } else {
      this.getMenuList.map(value => {
        if (value.ranking !== "" && Number.parseInt(value.ranking) > 0) {
          menuRecommended.push(value)
        }
      })
    }

    return menuRecommended.sort((a,b) => (a.ranking > b.ranking ? 1 : -1))
  }

  public openMenuDetail(menu, isEdit = false) {
    this.detailModal(menu, isEdit);
  }

  public detailModal(menu, isEdit) {
    (this.$refs.qDetailModal as QDetailModal).show(menu, isEdit);
  }
}
